import { render } from "./breadcrumb.vue?vue&type=template&id=8f55d7a2&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=8f55d7a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f55d7a2"],['__file',"src/js/components/breadcrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f55d7a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f55d7a2', __exports__)) {
    api.reload('8f55d7a2', __exports__)
  }
  
  module.hot.accept("./breadcrumb.vue?vue&type=template&id=8f55d7a2&scoped=true", () => {
    api.rerender('8f55d7a2', render)
  })

}


export default __exports__